import React, { useState } from "react";
import FirebaseContext from "./firebase/context";
import formImg from "../assets/img/form.svg"




export default function FormSection() {
    return (
        <div>
            <div className="row d-flex justify-content-center">
                <div className="col-lg-5 col-12 align-content-center">
                    <img  src={formImg} className="img-fluid form-image" alt="form"/>
                </div>
            <div className="col-lg-6 col-12 ">
                <div className=" form-section bg-white">
                  <FirebaseContext.Consumer>
                    {(firebase) => <ContactForm firebase={firebase} />}
                  </FirebaseContext.Consumer>
                </div>
              </div>
            </div>
           
        </div>
    )
}




const ContactForm = (props) => {
    const [name, setname] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
  
    // error message setState
    const [nameError, setnameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [subjectError, setSubjectError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [messageError, setMessageError] = useState("");
  
    const resetErrorMessage = () => {
      setnameError("");
      setEmailError("");
      setSubjectError("");
      setMessageError("");
    };
  
    const formValidate = () => {
      let hasError = false;
      if (!email.includes("@") || !email.includes(".com")) {
        setEmailError("Invalid Email!");
        hasError = true;
      }
      if (name === "") {
        setnameError("Name Can't be blank");
        hasError = true;
      }
      if (phone === "" ) {
        setPhoneError("Invalid Phone Number");
        hasError = true;
      }
      if (subject === "") {
        setSubjectError("Subject Can't be blank");
        hasError = true;
      }
      if (message === "") {
        setMessageError("Message Can't be blank");
        hasError = true;
      }
      if (hasError) return false;
      else return true;
    };
  
    const submit = (e) => {
      e.preventDefault();
      resetErrorMessage();
      let isValid = formValidate();
      console.log(isValid);
      if (isValid) {
        let data = {
          name: name,
          email: email,
          subject: subject,
          message: message,
          phone:phone
        };
  
        props.firebase.addData(data);
        setname("");
        setEmail("");
        setSubject("");
        setMessage("");
      }
    };
    return (
      <form className="p-5" action="">
        <div id="message-label">
          <p>Message Sended!</p>
        </div>
        <div className="row">
          <div className="col-md-6 col-12 d-flex flex-column">
            <input
              type="text"
              name="name"
              className="form-control"
              id="name"
              placeholder="Your Name"
              data-rule="minlen:4"
              data-msg="Please enter at least 4 chars"
              value={name}
              onChange={(e) => setname(e.target.value)}
            />
            <div className="error-message">{nameError}</div>
          </div>
          <div className="col-md-6 col-12">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Your Email"
              data-rule="minlen:4"
              data-msg="Please enter at least 4 chars"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="error-message">{emailError}</div>
          </div>
        </div>
        <div>
          <input
            type="text"
            className="form-control"
            name="phone"
            id="phone"
            placeholder="Phone Number"
            data-rule="minlen:10"
            data-msg="Invalid Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div className="error-message">{phoneError}</div>
        </div>
        <div>
          <input
            type="text"
            className="form-control"
            name="subject"
            id="subject"
            placeholder="Subject"
            data-rule="minlen:4"
            data-msg="Please enter at least 8 chars of subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <div className="error-message">{subjectError}</div>
        </div>
        <div>
          <textarea
            className="form-control"
            name="message"
            rows="5"
            data-rule="required"
            data-msg="Please write something for us"
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div className="error-message">{messageError}</div>
        </div>
        <div className="text-center">
          <button className="btn btn-primary" type="submit" onClick={submit}>
            Send Message
          </button>
        </div>
      </form>
    );
  };



